import { Form, Input } from 'antd';
import React from 'react';
import { Button } from '../../../../components/base/Button';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile } from '../../../../redux/selectors';
import { ButtonLink } from '../../../../components/base/Button/Link';
import { getCommonRoutePath } from '../../../../helpers/Helpers';
export var RecoverPasswordScreen = function () {
    var isMobile = useAppSelector(getIsMobile);
    var onFinish = function (values) {
        console.log(values);
    };
    return (React.createElement("div", { className: "flex items-center bg-gradient-to-r from-[#FFDAC7] to-[#CFE0FA] h-dvh overflow-hidden" },
        React.createElement("div", { className: "w-full bg-white mx-3 mb-2 rounded shadow-xl" },
            React.createElement("div", { className: "px-3 pt-4 pb-6 grid gap-3.5 [&>.ant-form-item]:mb-0" },
                React.createElement("p", { className: "text-reading-base font-semibold mb-0.5" }, "Recover password"),
                React.createElement(Form, { onFinish: onFinish, requiredMark: false, name: "sign-up-form", className: "sign-up-form", layout: "vertical" },
                    React.createElement(Form.Item, { name: "email", label: isMobile ? null : 'Email', rules: [
                            function (_a) {
                                var getFieldValue = _a.getFieldValue;
                                return ({
                                    validator: function () {
                                        var emailValue = getFieldValue('email');
                                        if (!emailValue) {
                                            return Promise.reject(new Error('Please enter your email address'));
                                        }
                                        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,16}$/i.test(emailValue)) {
                                            return Promise.reject(new Error('Invalid email address'));
                                        }
                                        return Promise.resolve();
                                    },
                                });
                            },
                        ] },
                        React.createElement(Input, { placeholder: "Email", type: "email" })),
                    React.createElement(Button, { htmlType: "submit", className: "w-full h-auto max-h-16 py-2 rounded-lg text-base" }, "Send"))),
            React.createElement(ButtonLink, { ghost: true, type: "link", className: "text-right p-0 text-natural-active h-auto", to: "".concat(getCommonRoutePath(), "/community/sign-in") }, "Forgot password?"))));
};
